import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Button } from 'semantic-ui-react';

const LoginButton = () => {
    const { loginWithRedirect } = useAuth0();

    return <div style={{ textAlign: 'center' }}>
        {/* Preserve the deep URL through the Auth0 roundtrip: AppWithAuth's
            onRedirectCallback restores appState.returnTo after login. Without
            it a logged-out user landing on e.g. /practice?opportunityId=…
            (portal deep links) would come back to "/" instead. Same pattern
            the re-auth bounce in UserContextProvider already uses. */}
        <Button primary onClick={() => loginWithRedirect({ appState: { returnTo: window.location.pathname + window.location.search } })}>Log In</Button>
        {/* <Button primary onClick={() => loginWithRedirect({ authorizationParams: { screen_hint: 'signup' } })}>Sign Up</Button> */}
    </div>;
};

export default LoginButton;
